import React from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { useParams } from "react-router-dom";
import "./PDFViewer.css";

const PDFViewer = () => {
    const { file } = useParams();
    const pdfUrl = decodeURIComponent(file); 
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <div className="pdf-viewer-container">
            {/* Download Button */}
            <div className="pdf-toolbar">
                <a href={pdfUrl} download>
                    <button className="download-btn">Download PDF</button>
                </a>
            </div>

            {/* PDF Viewer */}
            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.9.179/build/pdf.worker.min.js`}>
                <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
            </Worker>
        </div>
    );
};

export default PDFViewer;
